/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { buildDate } from '../services/builld-date';

/* eslint-disable react/prefer-stateless-function */

class DateCellRenderer extends Component {

    render() {

        return (
            <div className="date-cell-renderer">
                {buildDate(this.props.value)}
            </div>
        );

    }

}

DateCellRenderer.displayName = 'DateCellRenderer';
DateCellRenderer.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
};
export default DateCellRenderer;
